import { render, staticRenderFns } from "./ordersTable.vue?vue&type=template&id=1bf9807a&"
import script from "./ordersTable.vue?vue&type=script&lang=ts&"
export * from "./ordersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports